import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { map, share } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'iam.vendasta-local.com',
  'test': '',
  'demo': 'iam-api-demo.apigateway.co',
  'prod': 'iam-api-prod.apigateway.co',
  'production': 'iam-api-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class LoginRequest {
  static fromProto(proto) {
    if (!proto) {
      return new LoginRequest();
    }
    let m = new LoginRequest();
    /* eslint-disable  @typescript-eslint/no-unsafe-assignment */
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    if (typeof this.namespace === 'undefined' && typeof this.type === 'undefined' && typeof this.email === 'undefined' && typeof this.password === 'undefined' && typeof this.providerIdToken === 'undefined' && typeof this.provider === 'undefined') {
      return {};
    }
    return {
      'namespace': typeof this.namespace !== 'undefined' ? this.namespace : null,
      'type': typeof this.type !== 'undefined' ? this.type : null,
      'email': typeof this.email !== 'undefined' ? this.email : null,
      'password': typeof this.password !== 'undefined' ? this.password : null,
      'provider_id_token': typeof this.providerIdToken !== 'undefined' ? this.providerIdToken : null,
      'provider': typeof this.provider !== 'undefined' ? this.provider : null
    };
  }
}
class LoginResponse {
  static fromProto(proto) {
    /* eslint-disable */
    const m = new LoginResponse();
    m.sessionId = proto['session_id'];
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    if (typeof this.sessionId === 'undefined') {
      return {};
    }
    return {
      'sessionId': typeof this.sessionId !== 'undefined' ? this.sessionId : null
    };
  }
}
class LogoutResponse {
  static fromProto(proto) {
    let m = new LogoutResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    if (typeof this.success === 'undefined') {
      return {};
    }
    return {
      'success': typeof this.success !== 'undefined' ? this.success : null
    };
  }
}
class SSOLoginRequest {
  static fromProto(proto) {
    let m = new SSOLoginRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    if (typeof this.nextUrl === 'undefined' && typeof this.namespace === 'undefined' && typeof this.type === 'undefined') {
      return null;
    }
    return {
      'next_url': typeof this.nextUrl !== 'undefined' ? this.nextUrl : null,
      'namespace': typeof this.namespace !== 'undefined' ? this.namespace : null,
      'type': typeof this.type !== 'undefined' ? this.type : null
    };
  }
}

/* eslint-disable */
let IamHttpApiService = /*#__PURE__*/(() => {
  class IamHttpApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions(includeCredentials) {
      if (includeCredentials) {
        return {
          headers: new HttpHeaders({
            'Content-Type': 'application/x-www-form-urlencoded'
          }),
          withCredentials: true
        };
      }
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/x-www-form-urlencoded'
        })
      };
    }
    login(r) {
      const toApiJson = r.toApiJson;
      const request = typeof toApiJson !== 'undefined' ? r : new LoginRequest(r);
      return this.http.post(this._host + '/_ajax/v1/login', request.toApiJson(), this.apiOptions()).pipe(map(resp => LoginResponse.fromProto(resp)), share());
    }
    logout() {
      return this.http.post(this._host + '/_ajax/v1/logout', {}, this.apiOptions(true)).pipe(map(resp => LogoutResponse.fromProto(resp)), share());
    }
    ssoLogin(r) {
      const toApiJson = r.toApiJson;
      const request = typeof toApiJson !== 'undefined' ? r : new SSOLoginRequest(r);
      const params = new URLSearchParams();
      const apiJson = request.toApiJson();
      for (const key in apiJson) {
        if (!apiJson.hasOwnProperty(key)) {
          continue;
        }
        const value = apiJson[key];
        if (value === null) {
          continue;
        }
        params.append(key, value);
      }
      window.location.href = `${this._host}/sso-login?${params.toString()}`;
    }
  }
  IamHttpApiService.ɵfac = function IamHttpApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || IamHttpApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  IamHttpApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: IamHttpApiService,
    factory: IamHttpApiService.ɵfac,
    providedIn: 'root'
  });
  return IamHttpApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var PersonaType = /*#__PURE__*/function (PersonaType) {
  PersonaType["partner"] = "partner";
  PersonaType["partner_app"] = "partner_app";
  PersonaType["sales_person"] = "sales_person";
  PersonaType["smb"] = "smb";
  PersonaType["vendor"] = "vendor";
  PersonaType["digital_agent"] = "digital_agent";
  PersonaType["developer"] = "developer";
  PersonaType["success"] = "success";
  PersonaType["account_group"] = "account_group";
  PersonaType["crm_role"] = "crm_role";
  return PersonaType;
}(PersonaType || {});
class BasePersona {
  fromPersona(p) {
    const s = p.subject;
    this.subjectId = s.subjectId;
    this.email = s.email;
    this.created = s.created;
    this.updated = s.updated;
    this.lastLogin = s.lastLogin;
    this.userId = s.userId;
    return this.readAttributes(s.structAttributes);
  }
  readAttributes(attributes) {
    if (!attributes) {
      return this;
    }
    /* eslint-disable @typescript-eslint/no-unsafe-assignment */
    const attrs = getValueFromAttribute({
      structAttribute: {
        attributes: attributes.attributes
      }
    });
    Object.assign(this, attrs);
    return this;
  }
}
class TypedPersona extends BasePersona {}
class NamespacedPersona extends BasePersona {
  constructor() {
    super(...arguments);
    this.partnerId = '';
  }
  fromPersona(p) {
    this.partnerId = p.context.namespaced.namespace;
    return super.fromPersona(p);
  }
}
function getValueFromAttribute(attr) {
  if (typeof attr === 'undefined') {
    return null;
  } else if (typeof attr.stringAttribute !== 'undefined') {
    return attr.stringAttribute;
  } else if (typeof attr.intAttribute !== 'undefined') {
    return attr.intAttribute;
  } else if (typeof attr.doubleAttribute !== 'undefined') {
    return attr.doubleAttribute;
  } else if (typeof attr.boolAttribute !== 'undefined') {
    return attr.boolAttribute;
  } else if (typeof attr.listAttribute !== 'undefined') {
    const vals = [];
    /* eslint-disable @typescript-eslint/no-unsafe-return */
    if (typeof attr.listAttribute.attributes === 'undefined') {
      /* eslint-disable @typescript-eslint/no-unsafe-return */
      return vals;
    }
    for (const val of attr.listAttribute.attributes) {
      vals.push(getValueFromAttribute(val));
    }
    return vals;
  } else if (typeof attr.timestampAttribute !== 'undefined') {
    return attr.timestampAttribute;
  } else if (typeof attr.geopointAttribute !== 'undefined') {
    return attr.geopointAttribute;
  } else if (typeof attr.structAttribute !== 'undefined') {
    const result = {};
    for (const a in attr.structAttribute.attributes) {
      if (!attr.structAttribute.attributes.hasOwnProperty(a)) {
        continue;
      }
      /* eslint-disable @typescript-eslint/no-unsafe-member-access */
      result[CamelCase(a)] = getValueFromAttribute(attr.structAttribute.attributes[a]);
    }
    return result;
  }
}
function CamelCase(str) {
  let result = '';
  for (let i = 0; i < str.length; i++) {
    if (str[i] === '_') {
      result += str[i + 1].toUpperCase();
      i++;
    } else {
      result += str[i];
    }
  }
  return result;
}
class DeveloperPersona extends TypedPersona {
  constructor() {
    super(...arguments);
    this.type = PersonaType.developer;
  }
}
class PartnerPersona extends TypedPersona {
  constructor() {
    super(...arguments);
    this.type = PersonaType.partner;
    this.isSuperAdmin = false;
    this.isAdmin = false;
    this.canCustomizeWhitelabel = false;
    this.canAccessBilling = false;
    this.canAccessAccounts = false;
    this.canAccessMarketing = false;
    this.canAccessSales = false;
    this.canAccessConcierge = false;
    this.canAccessBrands = false;
    this.canAccessDashboard = false;
    this.canAccessOrders = false;
    this.canAccessCompanyProfile = false;
    this.canAccessAutomations = false;
    this.canAccessMarketplace = false;
    this.canEnableApps = false;
    this.canAccessRetailBilling = false;
  }
}
class PartnerAppPersona extends NamespacedPersona {
  constructor() {
    super(...arguments);
    this.type = PersonaType.partner_app;
  }
}
const TitleChoice = {
  PARTNER_FOR_SMB: 'partnerForSmb',
  REP_MAN_FOR_SMB: 'repManForSmb',
  MARKET_FOR_SMB: 'marketForSmb'
};
const AccessLevel = {
  NONE: 'none',
  ALL: 'all',
  OWNED: 'owned'
};
class SalespersonPersona extends NamespacedPersona {
  constructor() {
    super(...arguments);
    this.type = PersonaType.sales_person;
    this.canAccessProposals = true;
    this.canAccessInbox = true;
    this.canAccessLeaderboard = true;
    this.canAccessPricing = true;
    this.ordersAccessScope = AccessLevel.ALL;
    this.opportunitiesAccessScope = AccessLevel.ALL;
    this.titleChoice = TitleChoice.PARTNER_FOR_SMB;
  }
}
class SMBPersona extends NamespacedPersona {
  constructor() {
    super(...arguments);
    this.type = PersonaType.smb;
    this.notificationsEnabled = true;
  }
}
class VendorPersona extends TypedPersona {
  constructor() {
    super(...arguments);
    this.type = PersonaType.vendor;
  }
}
class DigitalAgentPersona extends TypedPersona {
  constructor() {
    super(...arguments);
    this.type = PersonaType.digital_agent;
  }
}
class SuccessPersona extends TypedPersona {
  constructor() {
    super(...arguments);
    this.type = PersonaType.success;
  }
}
class AccountGroupPersona extends TypedPersona {
  constructor() {
    super(...arguments);
    this.type = PersonaType.account_group;
  }
}
class CRMRolePersona extends NamespacedPersona {
  constructor() {
    super(...arguments);
    this.type = PersonaType.crm_role;
  }
}
function fromPersona(persona) {
  const type = getTypeFromContext(persona.context);
  if (type === null) {
    return null;
  }
  const personaCls = getPersonaFromType(type);
  personaCls.fromPersona(persona);
  return personaCls;
}
function getTypeFromContext(ctx) {
  const type = !!ctx.namespaced ? ctx.namespaced.type : ctx.typed.type;
  switch (type) {
    case 'partner':
      return PersonaType.partner;
    case 'partner_app':
      return PersonaType.partner_app;
    case 'sales_person':
      return PersonaType.sales_person;
    case 'smb':
      return PersonaType.smb;
    case 'vendor':
      return PersonaType.vendor;
    case 'digital_agent':
      return PersonaType.digital_agent;
    case 'developer':
      return PersonaType.developer;
    case 'success':
      return PersonaType.success;
    case 'account_group':
      return PersonaType.account_group;
    case 'crm_role':
      return PersonaType.crm_role;
  }
  return null;
}
function getPersonaFromType(personaType) {
  return new {
    'partner': PartnerPersona,
    'partner_app': PartnerAppPersona,
    'sales_person': SalespersonPersona,
    'smb': SMBPersona,
    'vendor': VendorPersona,
    'digital_agent': DigitalAgentPersona,
    'developer': DeveloperPersona,
    'success': SuccessPersona,
    'account_group': AccountGroupPersona,
    'crm_role': CRMRolePersona
  }[personaType]();
}
function enumStringToValue$8(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class FieldMask {
  static fromProto(proto) {
    let m = new FieldMask();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paths !== 'undefined') {
      toReturn['paths'] = this.paths;
    }
    return toReturn;
  }
}
function enumStringToValue$7(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Attribute {
  static fromProto(proto) {
    let m = new Attribute();
    m = Object.assign(m, proto);
    if (proto.intAttribute) {
      m.intAttribute = parseInt(proto.intAttribute, 10);
    }
    if (proto.structAttribute) {
      m.structAttribute = StructAttribute.fromProto(proto.structAttribute);
    }
    if (proto.listAttribute) {
      m.listAttribute = ListAttribute.fromProto(proto.listAttribute);
    }
    if (proto.timestampAttribute) {
      m.timestampAttribute = new Date(proto.timestampAttribute);
    }
    if (proto.geopointAttribute) {
      m.geopointAttribute = GeoPointAttribute.fromProto(proto.geopointAttribute);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.intAttribute !== 'undefined') {
      toReturn['intAttribute'] = this.intAttribute;
    }
    if (typeof this.doubleAttribute !== 'undefined') {
      toReturn['doubleAttribute'] = this.doubleAttribute;
    }
    if (typeof this.stringAttribute !== 'undefined') {
      toReturn['stringAttribute'] = this.stringAttribute;
    }
    if (typeof this.boolAttribute !== 'undefined') {
      toReturn['boolAttribute'] = this.boolAttribute;
    }
    if (typeof this.structAttribute !== 'undefined' && this.structAttribute !== null) {
      toReturn['structAttribute'] = 'toApiJson' in this.structAttribute ? this.structAttribute.toApiJson() : this.structAttribute;
    }
    if (typeof this.listAttribute !== 'undefined' && this.listAttribute !== null) {
      toReturn['listAttribute'] = 'toApiJson' in this.listAttribute ? this.listAttribute.toApiJson() : this.listAttribute;
    }
    if (typeof this.timestampAttribute !== 'undefined' && this.timestampAttribute !== null) {
      toReturn['timestampAttribute'] = 'toApiJson' in this.timestampAttribute ? this.timestampAttribute.toApiJson() : this.timestampAttribute;
    }
    if (typeof this.geopointAttribute !== 'undefined' && this.geopointAttribute !== null) {
      toReturn['geopointAttribute'] = 'toApiJson' in this.geopointAttribute ? this.geopointAttribute.toApiJson() : this.geopointAttribute;
    }
    return toReturn;
  }
}
class StructAttributeAttributesEntry {
  static fromProto(proto) {
    let m = new StructAttributeAttributesEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = Attribute.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class GeoPointAttribute {
  static fromProto(proto) {
    let m = new GeoPointAttribute();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.latitude !== 'undefined') {
      toReturn['latitude'] = this.latitude;
    }
    if (typeof this.longitude !== 'undefined') {
      toReturn['longitude'] = this.longitude;
    }
    return toReturn;
  }
}
class ListAttribute {
  static fromProto(proto) {
    let m = new ListAttribute();
    m = Object.assign(m, proto);
    if (proto.attributes) {
      m.attributes = proto.attributes.map(Attribute.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.attributes !== 'undefined' && this.attributes !== null) {
      toReturn['attributes'] = 'toApiJson' in this.attributes ? this.attributes.toApiJson() : this.attributes;
    }
    return toReturn;
  }
}
class StructAttribute {
  static fromProto(proto) {
    let m = new StructAttribute();
    m = Object.assign(m, proto);
    if (proto.attributes) {
      m.attributes = Object.keys(proto.attributes).reduce((obj, k) => {
        obj[k] = Attribute.fromProto(proto.attributes[k]);
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.attributes !== 'undefined' && this.attributes !== null) {
      toReturn['attributes'] = 'toApiJson' in this.attributes ? this.attributes.toApiJson() : this.attributes;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var BooleanOperator = /*#__PURE__*/function (BooleanOperator) {
  BooleanOperator[BooleanOperator["AND"] = 0] = "AND";
  BooleanOperator[BooleanOperator["OR"] = 1] = "OR";
  BooleanOperator[BooleanOperator["NOT"] = 2] = "NOT";
  return BooleanOperator;
}(BooleanOperator || {});
var ForOperator = /*#__PURE__*/function (ForOperator) {
  ForOperator[ForOperator["ANY"] = 0] = "ANY";
  ForOperator[ForOperator["ALL"] = 1] = "ALL";
  return ForOperator;
}(ForOperator || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var AccessScope = /*#__PURE__*/function (AccessScope) {
  AccessScope[AccessScope["READ"] = 0] = "READ";
  AccessScope[AccessScope["WRITE"] = 1] = "WRITE";
  AccessScope[AccessScope["DELETE"] = 2] = "DELETE";
  AccessScope[AccessScope["LIST"] = 3] = "LIST";
  return AccessScope;
}(AccessScope || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var AlgorithmType = /*#__PURE__*/function (AlgorithmType) {
  AlgorithmType[AlgorithmType["ALGORITHM_TYPE_ES256"] = 0] = "ALGORITHM_TYPE_ES256";
  AlgorithmType[AlgorithmType["ALGORITHM_TYPE_RS256"] = 1] = "ALGORITHM_TYPE_RS256";
  return AlgorithmType;
}(AlgorithmType || {});
var OrderByDirection = /*#__PURE__*/function (OrderByDirection) {
  OrderByDirection[OrderByDirection["ASCENDING"] = 0] = "ASCENDING";
  OrderByDirection[OrderByDirection["DESCENDING"] = 1] = "DESCENDING";
  return OrderByDirection;
}(OrderByDirection || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var RestrictionType = /*#__PURE__*/function (RestrictionType) {
  RestrictionType[RestrictionType["RESTRICTION_TYPE_UNSET"] = 0] = "RESTRICTION_TYPE_UNSET";
  RestrictionType[RestrictionType["RESTRICTION_TYPE_RESET_PASSWORD_BEFORE_LOGIN"] = 1] = "RESTRICTION_TYPE_RESET_PASSWORD_BEFORE_LOGIN";
  RestrictionType[RestrictionType["RESTRICTION_TYPE_FROZEN"] = 2] = "RESTRICTION_TYPE_FROZEN";
  return RestrictionType;
}(RestrictionType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var SortDirection = /*#__PURE__*/function (SortDirection) {
  SortDirection[SortDirection["SORT_DIRECTION_INVALID"] = 0] = "SORT_DIRECTION_INVALID";
  SortDirection[SortDirection["SORT_DIRECTION_ASCENDING"] = 1] = "SORT_DIRECTION_ASCENDING";
  SortDirection[SortDirection["SORT_DIRECTION_DESCENDING"] = 2] = "SORT_DIRECTION_DESCENDING";
  return SortDirection;
}(SortDirection || {});
var UserSortField = /*#__PURE__*/function (UserSortField) {
  UserSortField[UserSortField["USER_SORT_FIELD_INVALID"] = 0] = "USER_SORT_FIELD_INVALID";
  UserSortField[UserSortField["USER_SORT_FIELD_CREATED"] = 1] = "USER_SORT_FIELD_CREATED";
  UserSortField[UserSortField["USER_SORT_FIELD_FIRST_NAME"] = 2] = "USER_SORT_FIELD_FIRST_NAME";
  UserSortField[UserSortField["USER_SORT_FIELD_LAST_NAME"] = 3] = "USER_SORT_FIELD_LAST_NAME";
  UserSortField[UserSortField["USER_SORT_FIELD_EMAIL"] = 4] = "USER_SORT_FIELD_EMAIL";
  UserSortField[UserSortField["USER_SORT_FIELD_LAST_LOGIN"] = 5] = "USER_SORT_FIELD_LAST_LOGIN";
  return UserSortField;
}(UserSortField || {});
// *********************************

// NOTE: THIS HAS BEEN MANUALLY EDITED. PLEASE SEE THE BELOW COMMENTS TO SEE WHERE IT HAS BEEN EDITED
function enumStringToValue$6(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class IfClause {
  static fromProto(proto) {
    let m = new IfClause();
    m = Object.assign(m, proto);
    if (proto.resourceAttributeValue) {
      m.resourceAttributeValue = Attribute.fromProto(proto.resourceAttributeValue);
    }
    if (proto.thenPolicy) {
      m.thenPolicy = PolicyNode.fromProto(proto.thenPolicy);
    }
    if (proto.elsePolicy) {
      m.elsePolicy = PolicyNode.fromProto(proto.elsePolicy);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.resourceAttributeName !== 'undefined') {
      toReturn['resourceAttributeName'] = this.resourceAttributeName;
    }
    if (typeof this.resourceAttributeValue !== 'undefined' && this.resourceAttributeValue !== null) {
      toReturn['resourceAttributeValue'] = 'toApiJson' in this.resourceAttributeValue ? this.resourceAttributeValue.toApiJson() : this.resourceAttributeValue;
    }
    if (typeof this.thenPolicy !== 'undefined' && this.thenPolicy !== null) {
      toReturn['thenPolicy'] = 'toApiJson' in this.thenPolicy ? this.thenPolicy.toApiJson() : this.thenPolicy;
    }
    if (typeof this.elsePolicy !== 'undefined' && this.elsePolicy !== null) {
      toReturn['elsePolicy'] = 'toApiJson' in this.elsePolicy ? this.elsePolicy.toApiJson() : this.elsePolicy;
    }
    return toReturn;
  }
}
class Operator {
  static fromProto(proto) {
    let m = new Operator();
    m = Object.assign(m, proto);
    // Edited from e.policiesBooleanOperator to e.BooleanOperator
    if (proto.operator) {
      m.operator = enumStringToValue$6(BooleanOperator, proto.operator);
    }
    if (proto.children) {
      m.children = proto.children.map(PolicyNode.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.operator !== 'undefined') {
      toReturn['operator'] = this.operator;
    }
    if (typeof this.children !== 'undefined' && this.children !== null) {
      toReturn['children'] = 'toApiJson' in this.children ? this.children.toApiJson() : this.children;
    }
    return toReturn;
  }
}
class PolicyNode {
  static fromProto(proto) {
    let m = new PolicyNode();
    m = Object.assign(m, proto);
    if (proto.subjectResourceIntersection) {
      m.subjectResourceIntersection = SubjectResourceIntersectionClause.fromProto(proto.subjectResourceIntersection);
    }
    if (proto.operator) {
      m.operator = Operator.fromProto(proto.operator);
    }
    if (proto.subjectValueIntersection) {
      m.subjectValueIntersection = SubjectValueIntersectionClause.fromProto(proto.subjectValueIntersection);
    }
    if (proto.subjectMissingValue) {
      m.subjectMissingValue = SubjectMissingValueClause.fromProto(proto.subjectMissingValue);
    }
    if (proto.subjectResourceSubset) {
      m.subjectResourceSubset = SubjectResourceSubsetClause.fromProto(proto.subjectResourceSubset);
    }
    if (proto.subjectResourceFor) {
      m.subjectResourceFor = SubjectResourceForClause.fromProto(proto.subjectResourceFor);
    }
    if (proto.ifClause) {
      m.ifClause = IfClause.fromProto(proto.ifClause);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.subjectResourceIntersection !== 'undefined' && this.subjectResourceIntersection !== null) {
      toReturn['subjectResourceIntersection'] = 'toApiJson' in this.subjectResourceIntersection ? this.subjectResourceIntersection.toApiJson() : this.subjectResourceIntersection;
    }
    if (typeof this.operator !== 'undefined' && this.operator !== null) {
      toReturn['operator'] = 'toApiJson' in this.operator ? this.operator.toApiJson() : this.operator;
    }
    if (typeof this.subjectValueIntersection !== 'undefined' && this.subjectValueIntersection !== null) {
      toReturn['subjectValueIntersection'] = 'toApiJson' in this.subjectValueIntersection ? this.subjectValueIntersection.toApiJson() : this.subjectValueIntersection;
    }
    if (typeof this.subjectMissingValue !== 'undefined' && this.subjectMissingValue !== null) {
      toReturn['subjectMissingValue'] = 'toApiJson' in this.subjectMissingValue ? this.subjectMissingValue.toApiJson() : this.subjectMissingValue;
    }
    if (typeof this.subjectResourceSubset !== 'undefined' && this.subjectResourceSubset !== null) {
      toReturn['subjectResourceSubset'] = 'toApiJson' in this.subjectResourceSubset ? this.subjectResourceSubset.toApiJson() : this.subjectResourceSubset;
    }
    if (typeof this.subjectResourceFor !== 'undefined' && this.subjectResourceFor !== null) {
      toReturn['subjectResourceFor'] = 'toApiJson' in this.subjectResourceFor ? this.subjectResourceFor.toApiJson() : this.subjectResourceFor;
    }
    if (typeof this.ifClause !== 'undefined' && this.ifClause !== null) {
      toReturn['ifClause'] = 'toApiJson' in this.ifClause ? this.ifClause.toApiJson() : this.ifClause;
    }
    return toReturn;
  }
}
class SubjectMissingValueClause {
  static fromProto(proto) {
    let m = new SubjectMissingValueClause();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.attributeName !== 'undefined') {
      toReturn['attributeName'] = this.attributeName;
    }
    return toReturn;
  }
}
class SubjectResourceForClause {
  static fromProto(proto) {
    let m = new SubjectResourceForClause();
    m = Object.assign(m, proto);
    if (proto.operator) {
      m.operator = enumStringToValue$6(ForOperator, proto.operator);
    }
    if (proto.rules) {
      m.rules = PolicyNode.fromProto(proto.rules);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.attributeName !== 'undefined') {
      toReturn['attributeName'] = this.attributeName;
    }
    if (typeof this.operator !== 'undefined') {
      toReturn['operator'] = this.operator;
    }
    if (typeof this.rules !== 'undefined' && this.rules !== null) {
      toReturn['rules'] = 'toApiJson' in this.rules ? this.rules.toApiJson() : this.rules;
    }
    return toReturn;
  }
}
class SubjectResourceIntersectionClause {
  static fromProto(proto) {
    let m = new SubjectResourceIntersectionClause();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.attributeName !== 'undefined') {
      toReturn['attributeName'] = this.attributeName;
    }
    if (typeof this.resourceAttributeName !== 'undefined') {
      toReturn['resourceAttributeName'] = this.resourceAttributeName;
    }
    return toReturn;
  }
}
class SubjectResourceSubsetClause {
  static fromProto(proto) {
    let m = new SubjectResourceSubsetClause();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.attributeName !== 'undefined') {
      toReturn['attributeName'] = this.attributeName;
    }
    if (typeof this.resourceAttributeName !== 'undefined') {
      toReturn['resourceAttributeName'] = this.resourceAttributeName;
    }
    return toReturn;
  }
}
class SubjectValueIntersectionClause {
  static fromProto(proto) {
    let m = new SubjectValueIntersectionClause();
    m = Object.assign(m, proto);
    if (proto.structuredAttributeValue) {
      m.structuredAttributeValue = Attribute.fromProto(proto.structuredAttributeValue);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.attributeName !== 'undefined') {
      toReturn['attributeName'] = this.attributeName;
    }
    if (typeof this.attributeValue !== 'undefined') {
      toReturn['attributeValue'] = this.attributeValue;
    }
    if (typeof this.structuredAttributeValue !== 'undefined' && this.structuredAttributeValue !== null) {
      toReturn['structuredAttributeValue'] = 'toApiJson' in this.structuredAttributeValue ? this.structuredAttributeValue.toApiJson() : this.structuredAttributeValue;
    }
    return toReturn;
  }
}
function enumStringToValue$5(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AccessCheckFailures {
  static fromProto(proto) {
    let m = new AccessCheckFailures();
    m = Object.assign(m, proto);
    if (proto.failures) {
      m.failures = proto.failures.map(ResourceIdentifier.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.failures !== 'undefined' && this.failures !== null) {
      toReturn['failures'] = 'toApiJson' in this.failures ? this.failures.toApiJson() : this.failures;
    }
    return toReturn;
  }
}
class ResourceIdentifierIdentifiersEntry {
  static fromProto(proto) {
    let m = new ResourceIdentifierIdentifiersEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = ValueList.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class Policy {
  static fromProto(proto) {
    let m = new Policy();
    m = Object.assign(m, proto);
    if (proto.operations) {
      m.operations = proto.operations.map(v => enumStringToValue$5(AccessScope, v));
    }
    if (proto.policy) {
      m.policy = PolicyNode.fromProto(proto.policy);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.resourceId !== 'undefined') {
      toReturn['resourceId'] = this.resourceId;
    }
    if (typeof this.policyId !== 'undefined') {
      toReturn['policyId'] = this.policyId;
    }
    if (typeof this.policyName !== 'undefined') {
      toReturn['policyName'] = this.policyName;
    }
    if (typeof this.operations !== 'undefined') {
      toReturn['operations'] = this.operations;
    }
    if (typeof this.actions !== 'undefined') {
      toReturn['actions'] = this.actions;
    }
    if (typeof this.policy !== 'undefined' && this.policy !== null) {
      toReturn['policy'] = 'toApiJson' in this.policy ? this.policy.toApiJson() : this.policy;
    }
    return toReturn;
  }
}
class ResourceIdentifier {
  static fromProto(proto) {
    let m = new ResourceIdentifier();
    m = Object.assign(m, proto);
    if (proto.identifiers) {
      m.identifiers = Object.keys(proto.identifiers).reduce((obj, k) => {
        obj[k] = ValueList.fromProto(proto.identifiers[k]);
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identifiers !== 'undefined' && this.identifiers !== null) {
      toReturn['identifiers'] = 'toApiJson' in this.identifiers ? this.identifiers.toApiJson() : this.identifiers;
    }
    return toReturn;
  }
}
class ResourceOwner {
  static fromProto(proto) {
    let m = new ResourceOwner();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.appName !== 'undefined') {
      toReturn['appName'] = this.appName;
    }
    return toReturn;
  }
}
class ValueList {
  static fromProto(proto) {
    let m = new ValueList();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.values !== 'undefined') {
      toReturn['values'] = this.values;
    }
    return toReturn;
  }
}
function enumStringToValue$4(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Context {
  static fromProto(proto) {
    let m = new Context();
    m = Object.assign(m, proto);
    if (proto.namespaced) {
      m.namespaced = NamespacedContext.fromProto(proto.namespaced);
    }
    if (proto.typed) {
      m.typed = TypedContext.fromProto(proto.typed);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespaced !== 'undefined' && this.namespaced !== null) {
      toReturn['namespaced'] = 'toApiJson' in this.namespaced ? this.namespaced.toApiJson() : this.namespaced;
    }
    if (typeof this.typed !== 'undefined' && this.typed !== null) {
      toReturn['typed'] = 'toApiJson' in this.typed ? this.typed.toApiJson() : this.typed;
    }
    return toReturn;
  }
}
class MultiValueAttribute {
  static fromProto(proto) {
    let m = new MultiValueAttribute();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.values !== 'undefined') {
      toReturn['values'] = this.values;
    }
    return toReturn;
  }
}
class Mutation {
  static fromProto(proto) {
    let m = new Mutation();
    m = Object.assign(m, proto);
    if (proto.add) {
      m.add = SingleValueAttribute.fromProto(proto.add);
    }
    if (proto.replace) {
      m.replace = MultiValueAttribute.fromProto(proto.replace);
    }
    if (proto.remove) {
      m.remove = SingleValueAttribute.fromProto(proto.remove);
    }
    if (proto.replaceAttributes) {
      m.replaceAttributes = StructAttribute.fromProto(proto.replaceAttributes);
    }
    if (proto.addAttributes) {
      m.addAttributes = StructAttribute.fromProto(proto.addAttributes);
    }
    if (proto.removeAttributes) {
      m.removeAttributes = StructAttribute.fromProto(proto.removeAttributes);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.add !== 'undefined' && this.add !== null) {
      toReturn['add'] = 'toApiJson' in this.add ? this.add.toApiJson() : this.add;
    }
    if (typeof this.replace !== 'undefined' && this.replace !== null) {
      toReturn['replace'] = 'toApiJson' in this.replace ? this.replace.toApiJson() : this.replace;
    }
    if (typeof this.remove !== 'undefined' && this.remove !== null) {
      toReturn['remove'] = 'toApiJson' in this.remove ? this.remove.toApiJson() : this.remove;
    }
    if (typeof this.dropKey !== 'undefined') {
      toReturn['dropKey'] = this.dropKey;
    }
    if (typeof this.replaceAttributes !== 'undefined' && this.replaceAttributes !== null) {
      toReturn['replaceAttributes'] = 'toApiJson' in this.replaceAttributes ? this.replaceAttributes.toApiJson() : this.replaceAttributes;
    }
    if (typeof this.addAttributes !== 'undefined' && this.addAttributes !== null) {
      toReturn['addAttributes'] = 'toApiJson' in this.addAttributes ? this.addAttributes.toApiJson() : this.addAttributes;
    }
    if (typeof this.removeAttributes !== 'undefined' && this.removeAttributes !== null) {
      toReturn['removeAttributes'] = 'toApiJson' in this.removeAttributes ? this.removeAttributes.toApiJson() : this.removeAttributes;
    }
    return toReturn;
  }
}
class NamespacedContext {
  static fromProto(proto) {
    let m = new NamespacedContext();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    return toReturn;
  }
}
class Persona {
  static fromProto(proto) {
    let m = new Persona();
    m = Object.assign(m, proto);
    if (proto.subject) {
      m.subject = Subject.fromProto(proto.subject);
    }
    if (proto.context) {
      m.context = Context.fromProto(proto.context);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.subject !== 'undefined' && this.subject !== null) {
      toReturn['subject'] = 'toApiJson' in this.subject ? this.subject.toApiJson() : this.subject;
    }
    if (typeof this.context !== 'undefined' && this.context !== null) {
      toReturn['context'] = 'toApiJson' in this.context ? this.context.toApiJson() : this.context;
    }
    return toReturn;
  }
}
class PublicKey {
  static fromProto(proto) {
    let m = new PublicKey();
    m = Object.assign(m, proto);
    if (proto.algorithmType) {
      m.algorithmType = enumStringToValue$4(AlgorithmType, proto.algorithmType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.algorithmType !== 'undefined') {
      toReturn['algorithmType'] = this.algorithmType;
    }
    return toReturn;
  }
}
class Query {
  static fromProto(proto) {
    let m = new Query();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.attributeKeys !== 'undefined') {
      toReturn['attributeKeys'] = this.attributeKeys;
    }
    return toReturn;
  }
}
class SingleValueAttribute {
  static fromProto(proto) {
    let m = new SingleValueAttribute();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class Subject {
  static fromProto(proto) {
    let m = new Subject();
    m = Object.assign(m, proto);
    if (proto.attributes) {
      m.attributes = proto.attributes.map(MultiValueAttribute.fromProto);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.lastLogin) {
      m.lastLogin = new Date(proto.lastLogin);
    }
    if (proto.publicKeys) {
      m.publicKeys = proto.publicKeys.map(PublicKey.fromProto);
    }
    if (proto.structAttributes) {
      m.structAttributes = StructAttribute.fromProto(proto.structAttributes);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.subjectId !== 'undefined') {
      toReturn['subjectId'] = this.subjectId;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.attributes !== 'undefined' && this.attributes !== null) {
      toReturn['attributes'] = 'toApiJson' in this.attributes ? this.attributes.toApiJson() : this.attributes;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.lastLogin !== 'undefined' && this.lastLogin !== null) {
      toReturn['lastLogin'] = 'toApiJson' in this.lastLogin ? this.lastLogin.toApiJson() : this.lastLogin;
    }
    if (typeof this.publicKeys !== 'undefined' && this.publicKeys !== null) {
      toReturn['publicKeys'] = 'toApiJson' in this.publicKeys ? this.publicKeys.toApiJson() : this.publicKeys;
    }
    if (typeof this.structAttributes !== 'undefined' && this.structAttributes !== null) {
      toReturn['structAttributes'] = 'toApiJson' in this.structAttributes ? this.structAttributes.toApiJson() : this.structAttributes;
    }
    return toReturn;
  }
}
class SubjectResult {
  static fromProto(proto) {
    let m = new SubjectResult();
    m = Object.assign(m, proto);
    if (proto.subject) {
      m.subject = Subject.fromProto(proto.subject);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.subject !== 'undefined' && this.subject !== null) {
      toReturn['subject'] = 'toApiJson' in this.subject ? this.subject.toApiJson() : this.subject;
    }
    return toReturn;
  }
}
class TypedContext {
  static fromProto(proto) {
    let m = new TypedContext();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    return toReturn;
  }
}
function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class SecurityLog {
  static fromProto(proto) {
    let m = new SecurityLog();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.actionId !== 'undefined') {
      toReturn['actionId'] = this.actionId;
    }
    if (typeof this.logId !== 'undefined') {
      toReturn['logId'] = this.logId;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    return toReturn;
  }
}
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Identifier {
  static fromProto(proto) {
    let m = new Identifier();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.subjectId !== 'undefined') {
      toReturn['subjectId'] = this.subjectId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    return toReturn;
  }
}
class NamespacedEmail {
  static fromProto(proto) {
    let m = new NamespacedEmail();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    return toReturn;
  }
}
class NamespacedSession {
  static fromProto(proto) {
    let m = new NamespacedSession();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.session !== 'undefined') {
      toReturn['session'] = this.session;
    }
    return toReturn;
  }
}
class TypedExternalIdentifier {
  static fromProto(proto) {
    let m = new TypedExternalIdentifier();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.externalIdType !== 'undefined') {
      toReturn['externalIdType'] = this.externalIdType;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    return toReturn;
  }
}
class User {
  static fromProto(proto) {
    let m = new User();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.lastLogin) {
      m.lastLogin = new Date(proto.lastLogin);
    }
    if (proto.publicKeys) {
      m.publicKeys = proto.publicKeys.map(PublicKey.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.greetingName !== 'undefined') {
      toReturn['greetingName'] = this.greetingName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.languageCode !== 'undefined') {
      toReturn['languageCode'] = this.languageCode;
    }
    if (typeof this.emailVerified !== 'undefined') {
      toReturn['emailVerified'] = this.emailVerified;
    }
    if (typeof this.roles !== 'undefined') {
      toReturn['roles'] = this.roles;
    }
    if (typeof this.lastLogin !== 'undefined' && this.lastLogin !== null) {
      toReturn['lastLogin'] = 'toApiJson' in this.lastLogin ? this.lastLogin.toApiJson() : this.lastLogin;
    }
    if (typeof this.publicKeys !== 'undefined' && this.publicKeys !== null) {
      toReturn['publicKeys'] = 'toApiJson' in this.publicKeys ? this.publicKeys.toApiJson() : this.publicKeys;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Access {
  static fromProto(proto) {
    let m = new Access();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.public !== 'undefined') {
      toReturn['public'] = this.public;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AccessResourceRequest {
  static fromProto(proto) {
    let m = new AccessResourceRequest();
    m = Object.assign(m, proto);
    if (proto.context) {
      m.context = Context.fromProto(proto.context);
    }
    if (proto.resourceEntityIdentifier) {
      m.resourceEntityIdentifier = Object.keys(proto.resourceEntityIdentifier).reduce((obj, k) => {
        obj[k] = ValueList.fromProto(proto.resourceEntityIdentifier[k]);
        return obj;
      }, {});
    }
    if (proto.accessScope) {
      m.accessScope = proto.accessScope.map(v => enumStringToValue(AccessScope, v));
    }
    if (proto.resourceEntityIdentifiers) {
      m.resourceEntityIdentifiers = proto.resourceEntityIdentifiers.map(ResourceIdentifier.fromProto);
    }
    if (proto.resourceAttributes) {
      m.resourceAttributes = StructAttribute.fromProto(proto.resourceAttributes);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.context !== 'undefined' && this.context !== null) {
      toReturn['context'] = 'toApiJson' in this.context ? this.context.toApiJson() : this.context;
    }
    if (typeof this.subjectId !== 'undefined') {
      toReturn['subjectId'] = this.subjectId;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.session !== 'undefined') {
      toReturn['session'] = this.session;
    }
    if (typeof this.ownerId !== 'undefined') {
      toReturn['ownerId'] = this.ownerId;
    }
    if (typeof this.resourceId !== 'undefined') {
      toReturn['resourceId'] = this.resourceId;
    }
    if (typeof this.resourceEntityIdentifier !== 'undefined' && this.resourceEntityIdentifier !== null) {
      toReturn['resourceEntityIdentifier'] = 'toApiJson' in this.resourceEntityIdentifier ? this.resourceEntityIdentifier.toApiJson() : this.resourceEntityIdentifier;
    }
    if (typeof this.accessScope !== 'undefined') {
      toReturn['accessScope'] = this.accessScope;
    }
    if (typeof this.actions !== 'undefined') {
      toReturn['actions'] = this.actions;
    }
    if (typeof this.resourceEntityIdentifiers !== 'undefined' && this.resourceEntityIdentifiers !== null) {
      toReturn['resourceEntityIdentifiers'] = 'toApiJson' in this.resourceEntityIdentifiers ? this.resourceEntityIdentifiers.toApiJson() : this.resourceEntityIdentifiers;
    }
    if (typeof this.resourceAttributes !== 'undefined' && this.resourceAttributes !== null) {
      toReturn['resourceAttributes'] = 'toApiJson' in this.resourceAttributes ? this.resourceAttributes.toApiJson() : this.resourceAttributes;
    }
    return toReturn;
  }
}
class AddKeyRequest {
  static fromProto(proto) {
    let m = new AddKeyRequest();
    m = Object.assign(m, proto);
    if (proto.context) {
      m.context = Context.fromProto(proto.context);
    }
    if (proto.algorithmType) {
      m.algorithmType = enumStringToValue(AlgorithmType, proto.algorithmType);
    }
    if (proto.userIdentifier) {
      m.userIdentifier = UserIdentifier.fromProto(proto.userIdentifier);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.context !== 'undefined' && this.context !== null) {
      toReturn['context'] = 'toApiJson' in this.context ? this.context.toApiJson() : this.context;
    }
    if (typeof this.algorithmType !== 'undefined') {
      toReturn['algorithmType'] = this.algorithmType;
    }
    if (typeof this.userIdentifier !== 'undefined' && this.userIdentifier !== null) {
      toReturn['userIdentifier'] = 'toApiJson' in this.userIdentifier ? this.userIdentifier.toApiJson() : this.userIdentifier;
    }
    return toReturn;
  }
}
class AddKeyResponse {
  static fromProto(proto) {
    let m = new AddKeyResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.privateKey !== 'undefined') {
      toReturn['privateKey'] = this.privateKey;
    }
    if (typeof this.keyId !== 'undefined') {
      toReturn['keyId'] = this.keyId;
    }
    return toReturn;
  }
}
class AddMultiUserRestrictionRequest {
  static fromProto(proto) {
    let m = new AddMultiUserRestrictionRequest();
    m = Object.assign(m, proto);
    if (proto.userIdentifiers) {
      m.userIdentifiers = proto.userIdentifiers.map(UserIdentifier.fromProto);
    }
    if (proto.restrictionType) {
      m.restrictionType = enumStringToValue(RestrictionType, proto.restrictionType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userIdentifiers !== 'undefined' && this.userIdentifiers !== null) {
      toReturn['userIdentifiers'] = 'toApiJson' in this.userIdentifiers ? this.userIdentifiers.toApiJson() : this.userIdentifiers;
    }
    if (typeof this.restrictionType !== 'undefined') {
      toReturn['restrictionType'] = this.restrictionType;
    }
    return toReturn;
  }
}
class AuthenticateSubjectRequest {
  static fromProto(proto) {
    let m = new AuthenticateSubjectRequest();
    m = Object.assign(m, proto);
    if (proto.context) {
      m.context = Context.fromProto(proto.context);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.context !== 'undefined' && this.context !== null) {
      toReturn['context'] = 'toApiJson' in this.context ? this.context.toApiJson() : this.context;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.password !== 'undefined') {
      toReturn['password'] = this.password;
    }
    return toReturn;
  }
}
class ChangeSubjectEmailRequest {
  static fromProto(proto) {
    let m = new ChangeSubjectEmailRequest();
    m = Object.assign(m, proto);
    if (proto.context) {
      m.context = Context.fromProto(proto.context);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.context !== 'undefined' && this.context !== null) {
      toReturn['context'] = 'toApiJson' in this.context ? this.context.toApiJson() : this.context;
    }
    if (typeof this.subjectId !== 'undefined') {
      toReturn['subjectId'] = this.subjectId;
    }
    if (typeof this.newEmail !== 'undefined') {
      toReturn['newEmail'] = this.newEmail;
    }
    return toReturn;
  }
}
class CreateExternalIDRequest {
  static fromProto(proto) {
    let m = new CreateExternalIDRequest();
    m = Object.assign(m, proto);
    if (proto.userIdentifier) {
      m.userIdentifier = UserIdentifier.fromProto(proto.userIdentifier);
    }
    if (proto.typedExternalIdentifier) {
      m.typedExternalIdentifier = TypedExternalIdentifier.fromProto(proto.typedExternalIdentifier);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userIdentifier !== 'undefined' && this.userIdentifier !== null) {
      toReturn['userIdentifier'] = 'toApiJson' in this.userIdentifier ? this.userIdentifier.toApiJson() : this.userIdentifier;
    }
    if (typeof this.typedExternalIdentifier !== 'undefined' && this.typedExternalIdentifier !== null) {
      toReturn['typedExternalIdentifier'] = 'toApiJson' in this.typedExternalIdentifier ? this.typedExternalIdentifier.toApiJson() : this.typedExternalIdentifier;
    }
    return toReturn;
  }
}
class CreateSessionRequest {
  static fromProto(proto) {
    let m = new CreateSessionRequest();
    m = Object.assign(m, proto);
    if (proto.context) {
      m.context = Context.fromProto(proto.context);
    }
    if (proto.oauthCredentials) {
      m.oauthCredentials = OAuthCredentials.fromProto(proto.oauthCredentials);
    }
    if (proto.subjectCredentials) {
      m.subjectCredentials = SubjectCredentials.fromProto(proto.subjectCredentials);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.context !== 'undefined' && this.context !== null) {
      toReturn['context'] = 'toApiJson' in this.context ? this.context.toApiJson() : this.context;
    }
    if (typeof this.oauthCredentials !== 'undefined' && this.oauthCredentials !== null) {
      toReturn['oauthCredentials'] = 'toApiJson' in this.oauthCredentials ? this.oauthCredentials.toApiJson() : this.oauthCredentials;
    }
    if (typeof this.subjectCredentials !== 'undefined' && this.subjectCredentials !== null) {
      toReturn['subjectCredentials'] = 'toApiJson' in this.subjectCredentials ? this.subjectCredentials.toApiJson() : this.subjectCredentials;
    }
    return toReturn;
  }
}
class CreateSessionResponse {
  static fromProto(proto) {
    let m = new CreateSessionResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.session !== 'undefined') {
      toReturn['session'] = this.session;
    }
    return toReturn;
  }
}
class CreateTemporarySubjectRequest {
  static fromProto(proto) {
    let m = new CreateTemporarySubjectRequest();
    m = Object.assign(m, proto);
    if (proto.context) {
      m.context = Context.fromProto(proto.context);
    }
    if (proto.attributes) {
      m.attributes = StructAttribute.fromProto(proto.attributes);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.context !== 'undefined' && this.context !== null) {
      toReturn['context'] = 'toApiJson' in this.context ? this.context.toApiJson() : this.context;
    }
    if (typeof this.subject !== 'undefined') {
      toReturn['subject'] = this.subject;
    }
    if (typeof this.attributes !== 'undefined' && this.attributes !== null) {
      toReturn['attributes'] = 'toApiJson' in this.attributes ? this.attributes.toApiJson() : this.attributes;
    }
    return toReturn;
  }
}
class CreateTemporarySubjectResponse {
  static fromProto(proto) {
    let m = new CreateTemporarySubjectResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.session !== 'undefined') {
      toReturn['session'] = this.session;
    }
    return toReturn;
  }
}
class DeleteSubjectRequest {
  static fromProto(proto) {
    let m = new DeleteSubjectRequest();
    m = Object.assign(m, proto);
    if (proto.context) {
      m.context = Context.fromProto(proto.context);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.context !== 'undefined' && this.context !== null) {
      toReturn['context'] = 'toApiJson' in this.context ? this.context.toApiJson() : this.context;
    }
    if (typeof this.subjectId !== 'undefined') {
      toReturn['subjectId'] = this.subjectId;
    }
    return toReturn;
  }
}
class DeleteUserRequest {
  static fromProto(proto) {
    let m = new DeleteUserRequest();
    m = Object.assign(m, proto);
    if (proto.userIdentifier) {
      m.userIdentifier = UserIdentifier.fromProto(proto.userIdentifier);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userIdentifier !== 'undefined' && this.userIdentifier !== null) {
      toReturn['userIdentifier'] = 'toApiJson' in this.userIdentifier ? this.userIdentifier.toApiJson() : this.userIdentifier;
    }
    return toReturn;
  }
}
class ListSecurityLogsRequestFilters {
  static fromProto(proto) {
    let m = new ListSecurityLogsRequestFilters();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.actionId !== 'undefined') {
      toReturn['actionId'] = this.actionId;
    }
    return toReturn;
  }
}
class GetImpersonationTokenRequest {
  static fromProto(proto) {
    let m = new GetImpersonationTokenRequest();
    m = Object.assign(m, proto);
    if (proto.impersonatee) {
      m.impersonatee = UserIdentifier.fromProto(proto.impersonatee);
    }
    if (proto.impersonator) {
      m.impersonator = UserIdentifier.fromProto(proto.impersonator);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.impersonatee !== 'undefined' && this.impersonatee !== null) {
      toReturn['impersonatee'] = 'toApiJson' in this.impersonatee ? this.impersonatee.toApiJson() : this.impersonatee;
    }
    if (typeof this.impersonator !== 'undefined' && this.impersonator !== null) {
      toReturn['impersonator'] = 'toApiJson' in this.impersonator ? this.impersonator.toApiJson() : this.impersonator;
    }
    return toReturn;
  }
}
class GetImpersonationTokenResponse {
  static fromProto(proto) {
    let m = new GetImpersonationTokenResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.token !== 'undefined') {
      toReturn['token'] = this.token;
    }
    return toReturn;
  }
}
class GetMultiExternalIDRequest {
  static fromProto(proto) {
    let m = new GetMultiExternalIDRequest();
    m = Object.assign(m, proto);
    if (proto.userIdentifiers) {
      m.userIdentifiers = proto.userIdentifiers.map(UserIdentifier.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userIdentifiers !== 'undefined' && this.userIdentifiers !== null) {
      toReturn['userIdentifiers'] = 'toApiJson' in this.userIdentifiers ? this.userIdentifiers.toApiJson() : this.userIdentifiers;
    }
    if (typeof this.externalIdType !== 'undefined') {
      toReturn['externalIdType'] = this.externalIdType;
    }
    return toReturn;
  }
}
class GetMultiExternalIDResponse {
  static fromProto(proto) {
    let m = new GetMultiExternalIDResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.externalIds !== 'undefined') {
      toReturn['externalIds'] = this.externalIds;
    }
    return toReturn;
  }
}
class GetMultiUsersRequest {
  static fromProto(proto) {
    let m = new GetMultiUsersRequest();
    m = Object.assign(m, proto);
    if (proto.userIdentifiers) {
      m.userIdentifiers = proto.userIdentifiers.map(UserIdentifier.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userIdentifiers !== 'undefined' && this.userIdentifiers !== null) {
      toReturn['userIdentifiers'] = 'toApiJson' in this.userIdentifiers ? this.userIdentifiers.toApiJson() : this.userIdentifiers;
    }
    return toReturn;
  }
}
class GetMultiUsersResponse {
  static fromProto(proto) {
    let m = new GetMultiUsersResponse();
    m = Object.assign(m, proto);
    if (proto.users) {
      m.users = proto.users.map(GetMultiUsersResponseUserContainer.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.users !== 'undefined' && this.users !== null) {
      toReturn['users'] = 'toApiJson' in this.users ? this.users.toApiJson() : this.users;
    }
    return toReturn;
  }
}
class GetResetPasswordTokenRequest {
  static fromProto(proto) {
    let m = new GetResetPasswordTokenRequest();
    m = Object.assign(m, proto);
    if (proto.context) {
      m.context = Context.fromProto(proto.context);
    }
    if (proto.userIdentifier) {
      m.userIdentifier = UserIdentifier.fromProto(proto.userIdentifier);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.context !== 'undefined' && this.context !== null) {
      toReturn['context'] = 'toApiJson' in this.context ? this.context.toApiJson() : this.context;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.userIdentifier !== 'undefined' && this.userIdentifier !== null) {
      toReturn['userIdentifier'] = 'toApiJson' in this.userIdentifier ? this.userIdentifier.toApiJson() : this.userIdentifier;
    }
    return toReturn;
  }
}
class GetSessionTokenRequest {
  static fromProto(proto) {
    let m = new GetSessionTokenRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.token !== 'undefined') {
      toReturn['token'] = this.token;
    }
    return toReturn;
  }
}
class GetShortLivedTokenRequest {
  static fromProto(proto) {
    let m = new GetShortLivedTokenRequest();
    m = Object.assign(m, proto);
    if (proto.context) {
      m.context = Context.fromProto(proto.context);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.context !== 'undefined' && this.context !== null) {
      toReturn['context'] = 'toApiJson' in this.context ? this.context.toApiJson() : this.context;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    return toReturn;
  }
}
class GetSubjectBySessionRequest {
  static fromProto(proto) {
    let m = new GetSubjectBySessionRequest();
    m = Object.assign(m, proto);
    if (proto.context) {
      m.context = Context.fromProto(proto.context);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.session !== 'undefined') {
      toReturn['session'] = this.session;
    }
    if (typeof this.context !== 'undefined' && this.context !== null) {
      toReturn['context'] = 'toApiJson' in this.context ? this.context.toApiJson() : this.context;
    }
    return toReturn;
  }
}
class GetSubjectContextRequest {
  static fromProto(proto) {
    let m = new GetSubjectContextRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.subjectId !== 'undefined') {
      toReturn['subjectId'] = this.subjectId;
    }
    return toReturn;
  }
}
class GetSubjectContextResponse {
  static fromProto(proto) {
    let m = new GetSubjectContextResponse();
    m = Object.assign(m, proto);
    if (proto.context) {
      m.context = Context.fromProto(proto.context);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.context !== 'undefined' && this.context !== null) {
      toReturn['context'] = 'toApiJson' in this.context ? this.context.toApiJson() : this.context;
    }
    return toReturn;
  }
}
class GetSubjectResponse {
  static fromProto(proto) {
    let m = new GetSubjectResponse();
    m = Object.assign(m, proto);
    if (proto.subject) {
      m.subject = SubjectResult.fromProto(proto.subject);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.subject !== 'undefined' && this.subject !== null) {
      toReturn['subject'] = 'toApiJson' in this.subject ? this.subject.toApiJson() : this.subject;
    }
    return toReturn;
  }
}
class GetSubjectsByEmailRequest {
  static fromProto(proto) {
    let m = new GetSubjectsByEmailRequest();
    m = Object.assign(m, proto);
    if (proto.context) {
      m.context = Context.fromProto(proto.context);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.context !== 'undefined' && this.context !== null) {
      toReturn['context'] = 'toApiJson' in this.context ? this.context.toApiJson() : this.context;
    }
    if (typeof this.emails !== 'undefined') {
      toReturn['emails'] = this.emails;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class GetSubjectsRequest {
  static fromProto(proto) {
    let m = new GetSubjectsRequest();
    m = Object.assign(m, proto);
    if (proto.context) {
      m.context = Context.fromProto(proto.context);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    if (proto.identifiers) {
      m.identifiers = proto.identifiers.map(Identifier.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.context !== 'undefined' && this.context !== null) {
      toReturn['context'] = 'toApiJson' in this.context ? this.context.toApiJson() : this.context;
    }
    if (typeof this.subjectIds !== 'undefined') {
      toReturn['subjectIds'] = this.subjectIds;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    if (typeof this.identifiers !== 'undefined' && this.identifiers !== null) {
      toReturn['identifiers'] = 'toApiJson' in this.identifiers ? this.identifiers.toApiJson() : this.identifiers;
    }
    return toReturn;
  }
}
class GetSubjectsResponse {
  static fromProto(proto) {
    let m = new GetSubjectsResponse();
    m = Object.assign(m, proto);
    if (proto.subjects) {
      m.subjects = proto.subjects.map(SubjectResult.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.subjects !== 'undefined' && this.subjects !== null) {
      toReturn['subjects'] = 'toApiJson' in this.subjects ? this.subjects.toApiJson() : this.subjects;
    }
    return toReturn;
  }
}
class GetTokenRequest {
  static fromProto(proto) {
    let m = new GetTokenRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class GetTokenResponse {
  static fromProto(proto) {
    let m = new GetTokenResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.token !== 'undefined') {
      toReturn['token'] = this.token;
    }
    return toReturn;
  }
}
class IAMListPersonasRequest {
  static fromProto(proto) {
    let m = new IAMListPersonasRequest();
    m = Object.assign(m, proto);
    if (proto.userIdentifier) {
      m.userIdentifier = UserIdentifier.fromProto(proto.userIdentifier);
    }
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userIdentifier !== 'undefined' && this.userIdentifier !== null) {
      toReturn['userIdentifier'] = 'toApiJson' in this.userIdentifier ? this.userIdentifier.toApiJson() : this.userIdentifier;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.alwaysIncludeSuperadmin !== 'undefined') {
      toReturn['alwaysIncludeSuperadmin'] = this.alwaysIncludeSuperadmin;
    }
    return toReturn;
  }
}
class ListPersonasByEmailRequest {
  static fromProto(proto) {
    let m = new ListPersonasByEmailRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    return toReturn;
  }
}
class ListPersonasRequest {
  static fromProto(proto) {
    let m = new ListPersonasRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.session !== 'undefined') {
      toReturn['session'] = this.session;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    return toReturn;
  }
}
class ListPersonasResponse {
  static fromProto(proto) {
    let m = new ListPersonasResponse();
    m = Object.assign(m, proto);
    if (proto.personas) {
      m.personas = proto.personas.map(Persona.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.personas !== 'undefined' && this.personas !== null) {
      toReturn['personas'] = 'toApiJson' in this.personas ? this.personas.toApiJson() : this.personas;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class ListSecurityLogsRequest {
  static fromProto(proto) {
    let m = new ListSecurityLogsRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListSecurityLogsRequestFilters.fromProto(proto.filters);
    }
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    return toReturn;
  }
}
class ListSecurityLogsResponse {
  static fromProto(proto) {
    let m = new ListSecurityLogsResponse();
    m = Object.assign(m, proto);
    if (proto.logs) {
      m.logs = proto.logs.map(SecurityLog.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.logs !== 'undefined' && this.logs !== null) {
      toReturn['logs'] = 'toApiJson' in this.logs ? this.logs.toApiJson() : this.logs;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class ListUsersRequest {
  static fromProto(proto) {
    let m = new ListUsersRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    if (proto.userFilter) {
      m.userFilter = UserFilter.fromProto(proto.userFilter);
    }
    if (proto.sortOptions) {
      m.sortOptions = proto.sortOptions.map(UserSortOptions.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.userFilter !== 'undefined' && this.userFilter !== null) {
      toReturn['userFilter'] = 'toApiJson' in this.userFilter ? this.userFilter.toApiJson() : this.userFilter;
    }
    if (typeof this.sortOptions !== 'undefined' && this.sortOptions !== null) {
      toReturn['sortOptions'] = 'toApiJson' in this.sortOptions ? this.sortOptions.toApiJson() : this.sortOptions;
    }
    return toReturn;
  }
}
class ListUsersResponse {
  static fromProto(proto) {
    let m = new ListUsersResponse();
    m = Object.assign(m, proto);
    if (proto.users) {
      m.users = proto.users.map(User.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.users !== 'undefined' && this.users !== null) {
      toReturn['users'] = 'toApiJson' in this.users ? this.users.toApiJson() : this.users;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class MutateAttributesRequest {
  static fromProto(proto) {
    let m = new MutateAttributesRequest();
    m = Object.assign(m, proto);
    if (proto.context) {
      m.context = Context.fromProto(proto.context);
    }
    if (proto.mutations) {
      m.mutations = proto.mutations.map(Mutation.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.context !== 'undefined' && this.context !== null) {
      toReturn['context'] = 'toApiJson' in this.context ? this.context.toApiJson() : this.context;
    }
    if (typeof this.subjectId !== 'undefined') {
      toReturn['subjectId'] = this.subjectId;
    }
    if (typeof this.mutations !== 'undefined' && this.mutations !== null) {
      toReturn['mutations'] = 'toApiJson' in this.mutations ? this.mutations.toApiJson() : this.mutations;
    }
    return toReturn;
  }
}
class OAuthCredentials {
  static fromProto(proto) {
    let m = new OAuthCredentials();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.provider !== 'undefined') {
      toReturn['provider'] = this.provider;
    }
    if (typeof this.idToken !== 'undefined') {
      toReturn['idToken'] = this.idToken;
    }
    if (typeof this.accessToken !== 'undefined') {
      toReturn['accessToken'] = this.accessToken;
    }
    return toReturn;
  }
}
class UpdateUserRequestOperation {
  static fromProto(proto) {
    let m = new UpdateUserRequestOperation();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.greetingName !== 'undefined') {
      toReturn['greetingName'] = this.greetingName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.languageCode !== 'undefined') {
      toReturn['languageCode'] = this.languageCode;
    }
    return toReturn;
  }
}
class RegisterPolicyRequest {
  static fromProto(proto) {
    let m = new RegisterPolicyRequest();
    m = Object.assign(m, proto);
    if (proto.policy) {
      m.policy = Policy.fromProto(proto.policy);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.policy !== 'undefined' && this.policy !== null) {
      toReturn['policy'] = 'toApiJson' in this.policy ? this.policy.toApiJson() : this.policy;
    }
    return toReturn;
  }
}
class RegisterResourceOwnerRequest {
  static fromProto(proto) {
    let m = new RegisterResourceOwnerRequest();
    m = Object.assign(m, proto);
    if (proto.owner) {
      m.owner = ResourceOwner.fromProto(proto.owner);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.owner !== 'undefined' && this.owner !== null) {
      toReturn['owner'] = 'toApiJson' in this.owner ? this.owner.toApiJson() : this.owner;
    }
    return toReturn;
  }
}
class RegisterResourceRequest {
  static fromProto(proto) {
    let m = new RegisterResourceRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.resourceId !== 'undefined') {
      toReturn['resourceId'] = this.resourceId;
    }
    if (typeof this.resourceName !== 'undefined') {
      toReturn['resourceName'] = this.resourceName;
    }
    if (typeof this.resourceOwnerServiceUrl !== 'undefined') {
      toReturn['resourceOwnerServiceUrl'] = this.resourceOwnerServiceUrl;
    }
    if (typeof this.requiredResourceParams !== 'undefined') {
      toReturn['requiredResourceParams'] = this.requiredResourceParams;
    }
    if (typeof this.resourceOwnerAudience !== 'undefined') {
      toReturn['resourceOwnerAudience'] = this.resourceOwnerAudience;
    }
    return toReturn;
  }
}
class RegisterSubjectRequest {
  static fromProto(proto) {
    let m = new RegisterSubjectRequest();
    m = Object.assign(m, proto);
    if (proto.context) {
      m.context = Context.fromProto(proto.context);
    }
    if (proto.attributes) {
      m.attributes = proto.attributes.map(MultiValueAttribute.fromProto);
    }
    if (proto.structAttributes) {
      m.structAttributes = StructAttribute.fromProto(proto.structAttributes);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.context !== 'undefined' && this.context !== null) {
      toReturn['context'] = 'toApiJson' in this.context ? this.context.toApiJson() : this.context;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.password !== 'undefined') {
      toReturn['password'] = this.password;
    }
    if (typeof this.attributes !== 'undefined' && this.attributes !== null) {
      toReturn['attributes'] = 'toApiJson' in this.attributes ? this.attributes.toApiJson() : this.attributes;
    }
    if (typeof this.structAttributes !== 'undefined' && this.structAttributes !== null) {
      toReturn['structAttributes'] = 'toApiJson' in this.structAttributes ? this.structAttributes.toApiJson() : this.structAttributes;
    }
    return toReturn;
  }
}
class RegisterSubjectResponse {
  static fromProto(proto) {
    let m = new RegisterSubjectResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.subjectId !== 'undefined') {
      toReturn['subjectId'] = this.subjectId;
    }
    return toReturn;
  }
}
class RemoveKeyRequest {
  static fromProto(proto) {
    let m = new RemoveKeyRequest();
    m = Object.assign(m, proto);
    if (proto.context) {
      m.context = Context.fromProto(proto.context);
    }
    if (proto.userIdentifier) {
      m.userIdentifier = UserIdentifier.fromProto(proto.userIdentifier);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.context !== 'undefined' && this.context !== null) {
      toReturn['context'] = 'toApiJson' in this.context ? this.context.toApiJson() : this.context;
    }
    if (typeof this.keyId !== 'undefined') {
      toReturn['keyId'] = this.keyId;
    }
    if (typeof this.userIdentifier !== 'undefined' && this.userIdentifier !== null) {
      toReturn['userIdentifier'] = 'toApiJson' in this.userIdentifier ? this.userIdentifier.toApiJson() : this.userIdentifier;
    }
    return toReturn;
  }
}
class RemoveMultiUserRestrictionRequest {
  static fromProto(proto) {
    let m = new RemoveMultiUserRestrictionRequest();
    m = Object.assign(m, proto);
    if (proto.userIdentifiers) {
      m.userIdentifiers = proto.userIdentifiers.map(UserIdentifier.fromProto);
    }
    if (proto.restrictionType) {
      m.restrictionType = enumStringToValue(RestrictionType, proto.restrictionType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userIdentifiers !== 'undefined' && this.userIdentifiers !== null) {
      toReturn['userIdentifiers'] = 'toApiJson' in this.userIdentifiers ? this.userIdentifiers.toApiJson() : this.userIdentifiers;
    }
    if (typeof this.restrictionType !== 'undefined') {
      toReturn['restrictionType'] = this.restrictionType;
    }
    return toReturn;
  }
}
class ResetPasswordTokenResponse {
  static fromProto(proto) {
    let m = new ResetPasswordTokenResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.token !== 'undefined') {
      toReturn['token'] = this.token;
    }
    return toReturn;
  }
}
class ResetPasswordWithTokenRequest {
  static fromProto(proto) {
    let m = new ResetPasswordWithTokenRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.token !== 'undefined') {
      toReturn['token'] = this.token;
    }
    if (typeof this.password !== 'undefined') {
      toReturn['password'] = this.password;
    }
    return toReturn;
  }
}
class ResetSubjectPasswordRequest {
  static fromProto(proto) {
    let m = new ResetSubjectPasswordRequest();
    m = Object.assign(m, proto);
    if (proto.context) {
      m.context = Context.fromProto(proto.context);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.context !== 'undefined' && this.context !== null) {
      toReturn['context'] = 'toApiJson' in this.context ? this.context.toApiJson() : this.context;
    }
    if (typeof this.subjectId !== 'undefined') {
      toReturn['subjectId'] = this.subjectId;
    }
    if (typeof this.newPassword !== 'undefined') {
      toReturn['newPassword'] = this.newPassword;
    }
    return toReturn;
  }
}
class AccessResourceRequestResourceEntityIdentifierEntry {
  static fromProto(proto) {
    let m = new AccessResourceRequestResourceEntityIdentifierEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = ValueList.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class SearchSubjectRequest {
  static fromProto(proto) {
    let m = new SearchSubjectRequest();
    m = Object.assign(m, proto);
    if (proto.context) {
      m.context = Context.fromProto(proto.context);
    }
    if (proto.query) {
      m.query = Query.fromProto(proto.query);
    }
    if (proto.filters) {
      m.filters = proto.filters.map(SingleValueAttribute.fromProto);
    }
    if (proto.orderByDirection) {
      m.orderByDirection = enumStringToValue(OrderByDirection, proto.orderByDirection);
    }
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.context !== 'undefined' && this.context !== null) {
      toReturn['context'] = 'toApiJson' in this.context ? this.context.toApiJson() : this.context;
    }
    if (typeof this.query !== 'undefined' && this.query !== null) {
      toReturn['query'] = 'toApiJson' in this.query ? this.query.toApiJson() : this.query;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.orderBy !== 'undefined') {
      toReturn['orderBy'] = this.orderBy;
    }
    if (typeof this.orderByDirection !== 'undefined') {
      toReturn['orderByDirection'] = this.orderByDirection;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class SearchSubjectResponse {
  static fromProto(proto) {
    let m = new SearchSubjectResponse();
    m = Object.assign(m, proto);
    if (proto.result) {
      m.result = proto.result.map(SubjectResult.fromProto);
    }
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.result !== 'undefined' && this.result !== null) {
      toReturn['result'] = 'toApiJson' in this.result ? this.result.toApiJson() : this.result;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
class SendEmailVerificationRequest {
  static fromProto(proto) {
    let m = new SendEmailVerificationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    return toReturn;
  }
}
class SubjectCredentials {
  static fromProto(proto) {
    let m = new SubjectCredentials();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.password !== 'undefined') {
      toReturn['password'] = this.password;
    }
    return toReturn;
  }
}
class UpdateUserRequest {
  static fromProto(proto) {
    let m = new UpdateUserRequest();
    m = Object.assign(m, proto);
    if (proto.operations) {
      m.operations = proto.operations.map(UpdateUserRequestOperation.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.operations !== 'undefined' && this.operations !== null) {
      toReturn['operations'] = 'toApiJson' in this.operations ? this.operations.toApiJson() : this.operations;
    }
    return toReturn;
  }
}
class GetMultiUsersResponseUserContainer {
  static fromProto(proto) {
    let m = new GetMultiUsersResponseUserContainer();
    m = Object.assign(m, proto);
    if (proto.user) {
      m.user = User.fromProto(proto.user);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.user !== 'undefined' && this.user !== null) {
      toReturn['user'] = 'toApiJson' in this.user ? this.user.toApiJson() : this.user;
    }
    return toReturn;
  }
}
class UserFilter {
  static fromProto(proto) {
    let m = new UserFilter();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.subjectTypes !== 'undefined') {
      toReturn['subjectTypes'] = this.subjectTypes;
    }
    if (typeof this.searchTerms !== 'undefined') {
      toReturn['searchTerms'] = this.searchTerms;
    }
    return toReturn;
  }
}
class UserIdentifier {
  static fromProto(proto) {
    let m = new UserIdentifier();
    m = Object.assign(m, proto);
    if (proto.namespacedEmail) {
      m.namespacedEmail = NamespacedEmail.fromProto(proto.namespacedEmail);
    }
    if (proto.namespacedSession) {
      m.namespacedSession = NamespacedSession.fromProto(proto.namespacedSession);
    }
    if (proto.typedExternalIdentifier) {
      m.typedExternalIdentifier = TypedExternalIdentifier.fromProto(proto.typedExternalIdentifier);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.namespacedEmail !== 'undefined' && this.namespacedEmail !== null) {
      toReturn['namespacedEmail'] = 'toApiJson' in this.namespacedEmail ? this.namespacedEmail.toApiJson() : this.namespacedEmail;
    }
    if (typeof this.namespacedSession !== 'undefined' && this.namespacedSession !== null) {
      toReturn['namespacedSession'] = 'toApiJson' in this.namespacedSession ? this.namespacedSession.toApiJson() : this.namespacedSession;
    }
    if (typeof this.token !== 'undefined') {
      toReturn['token'] = this.token;
    }
    if (typeof this.typedExternalIdentifier !== 'undefined' && this.typedExternalIdentifier !== null) {
      toReturn['typedExternalIdentifier'] = 'toApiJson' in this.typedExternalIdentifier ? this.typedExternalIdentifier.toApiJson() : this.typedExternalIdentifier;
    }
    if (typeof this.subjectId !== 'undefined') {
      toReturn['subjectId'] = this.subjectId;
    }
    return toReturn;
  }
}
class UserSortOptions {
  static fromProto(proto) {
    let m = new UserSortOptions();
    m = Object.assign(m, proto);
    if (proto.direction) {
      m.direction = enumStringToValue(SortDirection, proto.direction);
    }
    if (proto.field) {
      m.field = enumStringToValue(UserSortField, proto.field);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.direction !== 'undefined') {
      toReturn['direction'] = this.direction;
    }
    if (typeof this.field !== 'undefined') {
      toReturn['field'] = this.field;
    }
    return toReturn;
  }
}
class VerifyEmailRequest {
  static fromProto(proto) {
    let m = new VerifyEmailRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.token !== 'undefined') {
      toReturn['token'] = this.token;
    }
    return toReturn;
  }
}

// *********************************

// *********************************
let IAMApiService = /*#__PURE__*/(() => {
  class IAMApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    registerSubject(r) {
      const request = r.toApiJson ? r : new RegisterSubjectRequest(r);
      return this.http.post(this._host + "/iam.v1.IAM/RegisterSubject", request.toApiJson(), this.apiOptions()).pipe(map(resp => RegisterSubjectResponse.fromProto(resp)));
    }
    authenticateSubject(r) {
      const request = r.toApiJson ? r : new AuthenticateSubjectRequest(r);
      return this.http.post(this._host + "/iam.v1.IAM/AuthenticateSubject", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getSubjects(r) {
      const request = r.toApiJson ? r : new GetSubjectsRequest(r);
      return this.http.post(this._host + "/iam.v1.IAM/GetSubjects", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSubjectsResponse.fromProto(resp)));
    }
    getSubjectsByEmail(r) {
      const request = r.toApiJson ? r : new GetSubjectsByEmailRequest(r);
      return this.http.post(this._host + "/iam.v1.IAM/GetSubjectsByEmail", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSubjectsResponse.fromProto(resp)));
    }
    mutateAttributes(r) {
      const request = r.toApiJson ? r : new MutateAttributesRequest(r);
      return this.http.post(this._host + "/iam.v1.IAM/MutateAttributes", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    resetSubjectPassword(r) {
      const request = r.toApiJson ? r : new ResetSubjectPasswordRequest(r);
      return this.http.post(this._host + "/iam.v1.IAM/ResetSubjectPassword", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    changeSubjectEmail(r) {
      const request = r.toApiJson ? r : new ChangeSubjectEmailRequest(r);
      return this.http.post(this._host + "/iam.v1.IAM/ChangeSubjectEmail", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteSubject(r) {
      const request = r.toApiJson ? r : new DeleteSubjectRequest(r);
      return this.http.post(this._host + "/iam.v1.IAM/DeleteSubject", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    searchSubject(r) {
      const request = r.toApiJson ? r : new SearchSubjectRequest(r);
      return this.http.post(this._host + "/iam.v1.IAM/SearchSubject", request.toApiJson(), this.apiOptions()).pipe(map(resp => SearchSubjectResponse.fromProto(resp)));
    }
    getSubjectContext(r) {
      const request = r.toApiJson ? r : new GetSubjectContextRequest(r);
      return this.http.post(this._host + "/iam.v1.IAM/GetSubjectContext", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSubjectContextResponse.fromProto(resp)));
    }
    registerResourceOwner(r) {
      const request = r.toApiJson ? r : new RegisterResourceOwnerRequest(r);
      return this.http.post(this._host + "/iam.v1.IAM/RegisterResourceOwner", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    registerResource(r) {
      const request = r.toApiJson ? r : new RegisterResourceRequest(r);
      return this.http.post(this._host + "/iam.v1.IAM/RegisterResource", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    registerPolicy(r) {
      const request = r.toApiJson ? r : new RegisterPolicyRequest(r);
      return this.http.post(this._host + "/iam.v1.IAM/RegisterPolicy", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    accessResource(r) {
      const request = r.toApiJson ? r : new AccessResourceRequest(r);
      return this.http.post(this._host + "/iam.v1.IAM/AccessResource", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getShortLivedToken(r) {
      const request = r.toApiJson ? r : new GetShortLivedTokenRequest(r);
      return this.http.post(this._host + "/iam.v1.IAM/GetShortLivedToken", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetTokenResponse.fromProto(resp)));
    }
    getSessionToken(r) {
      const request = r.toApiJson ? r : new GetSessionTokenRequest(r);
      return this.http.post(this._host + "/iam.v1.IAM/GetSessionToken", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetTokenResponse.fromProto(resp)));
    }
    addKey(r) {
      const request = r.toApiJson ? r : new AddKeyRequest(r);
      return this.http.post(this._host + "/iam.v1.IAM/AddKey", request.toApiJson(), this.apiOptions()).pipe(map(resp => AddKeyResponse.fromProto(resp)));
    }
    removeKey(r) {
      const request = r.toApiJson ? r : new RemoveKeyRequest(r);
      return this.http.post(this._host + "/iam.v1.IAM/RemoveKey", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    createSession(r) {
      const request = r.toApiJson ? r : new CreateSessionRequest(r);
      return this.http.post(this._host + "/iam.v1.IAM/CreateSession", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateSessionResponse.fromProto(resp)));
    }
    getResetPasswordToken(r) {
      const request = r.toApiJson ? r : new GetResetPasswordTokenRequest(r);
      return this.http.post(this._host + "/iam.v1.IAM/GetResetPasswordToken", request.toApiJson(), this.apiOptions()).pipe(map(resp => ResetPasswordTokenResponse.fromProto(resp)));
    }
    listPersonasByEmail(r) {
      const request = r.toApiJson ? r : new ListPersonasByEmailRequest(r);
      return this.http.post(this._host + "/iam.v1.IAM/ListPersonasByEmail", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListPersonasResponse.fromProto(resp)));
    }
    listPersonas(r) {
      const request = r.toApiJson ? r : new IAMListPersonasRequest(r);
      return this.http.post(this._host + "/iam.v1.IAM/ListPersonas", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListPersonasResponse.fromProto(resp)));
    }
    createTemporarySubject(r) {
      const request = r.toApiJson ? r : new CreateTemporarySubjectRequest(r);
      return this.http.post(this._host + "/iam.v1.IAM/CreateTemporarySubject", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateTemporarySubjectResponse.fromProto(resp)));
    }
    getMultiUsers(r) {
      const request = r.toApiJson ? r : new GetMultiUsersRequest(r);
      return this.http.post(this._host + "/iam.v1.IAM/GetMultiUsers", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiUsersResponse.fromProto(resp)));
    }
    listUsers(r) {
      const request = r.toApiJson ? r : new ListUsersRequest(r);
      return this.http.post(this._host + "/iam.v1.IAM/ListUsers", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListUsersResponse.fromProto(resp)));
    }
    updateUser(r) {
      const request = r.toApiJson ? r : new UpdateUserRequest(r);
      return this.http.post(this._host + "/iam.v1.IAM/UpdateUser", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteUser(r) {
      const request = r.toApiJson ? r : new DeleteUserRequest(r);
      return this.http.post(this._host + "/iam.v1.IAM/DeleteUser", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listSecurityLogs(r) {
      const request = r.toApiJson ? r : new ListSecurityLogsRequest(r);
      return this.http.post(this._host + "/iam.v1.IAM/ListSecurityLogs", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListSecurityLogsResponse.fromProto(resp)));
    }
    verifyEmail(r) {
      const request = r.toApiJson ? r : new VerifyEmailRequest(r);
      return this.http.post(this._host + "/iam.v1.IAM/VerifyEmail", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    sendEmailVerification(r) {
      const request = r.toApiJson ? r : new SendEmailVerificationRequest(r);
      return this.http.post(this._host + "/iam.v1.IAM/SendEmailVerification", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getMultiExternalId(r) {
      const request = r.toApiJson ? r : new GetMultiExternalIDRequest(r);
      return this.http.post(this._host + "/iam.v1.IAM/GetMultiExternalID", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiExternalIDResponse.fromProto(resp)));
    }
    createExternalId(r) {
      const request = r.toApiJson ? r : new CreateExternalIDRequest(r);
      return this.http.post(this._host + "/iam.v1.IAM/CreateExternalID", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    addMultiUserRestriction(r) {
      const request = r.toApiJson ? r : new AddMultiUserRestrictionRequest(r);
      return this.http.post(this._host + "/iam.v1.IAM/AddMultiUserRestriction", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    removeMultiUserRestriction(r) {
      const request = r.toApiJson ? r : new RemoveMultiUserRestrictionRequest(r);
      return this.http.post(this._host + "/iam.v1.IAM/RemoveMultiUserRestriction", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  IAMApiService.ɵfac = function IAMApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || IAMApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  IAMApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: IAMApiService,
    factory: IAMApiService.ɵfac,
    providedIn: 'root'
  });
  return IAMApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let UserIAMApiService = /*#__PURE__*/(() => {
  class UserIAMApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getSubjectBySession(r) {
      const request = r.toApiJson ? r : new GetSubjectBySessionRequest(r);
      return this.http.post(this._host + "/iam.v1.UserIAM/GetSubjectBySession", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSubjectResponse.fromProto(resp)));
    }
    listPersonas(r) {
      const request = r.toApiJson ? r : new ListPersonasRequest(r);
      return this.http.post(this._host + "/iam.v1.UserIAM/ListPersonas", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListPersonasResponse.fromProto(resp)));
    }
    getToken(r) {
      const request = r.toApiJson ? r : new GetTokenRequest(r);
      return this.http.post(this._host + "/iam.v1.UserIAM/GetToken", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetTokenResponse.fromProto(resp)));
    }
    getSessionToken(r) {
      const request = r.toApiJson ? r : new GetSessionTokenRequest(r);
      return this.http.post(this._host + "/iam.v1.UserIAM/GetSessionToken", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetTokenResponse.fromProto(resp)));
    }
    resetPasswordWithToken(r) {
      const request = r.toApiJson ? r : new ResetPasswordWithTokenRequest(r);
      return this.http.post(this._host + "/iam.v1.UserIAM/ResetPasswordWithToken", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getImpersonationToken(r) {
      const request = r.toApiJson ? r : new GetImpersonationTokenRequest(r);
      return this.http.post(this._host + "/iam.v1.UserIAM/GetImpersonationToken", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetImpersonationTokenResponse.fromProto(resp)));
    }
  }
  UserIAMApiService.ɵfac = function UserIAMApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || UserIAMApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  UserIAMApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: UserIAMApiService,
    factory: UserIAMApiService.ɵfac,
    providedIn: 'root'
  });
  return UserIAMApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IAMService = /*#__PURE__*/(() => {
  class IAMService {
    constructor(api, httpApi, iamApi) {
      this.api = api;
      this.httpApi = httpApi;
      this.iamApi = iamApi;
    }
    // Get a subject from the session ID
    getSubjectBySession(sessionId, personaType, partnerId) {
      let context;
      if (!!partnerId) {
        context = new Context({
          namespaced: new NamespacedContext({
            namespace: partnerId,
            type: PersonaType[personaType]
          })
        });
      } else {
        context = new Context({
          typed: new TypedContext({
            type: PersonaType[personaType]
          })
        });
      }
      return this.api.getSubjectBySession({
        session: sessionId,
        context: context
      }).pipe(map(r => fromPersona(new Persona({
        subject: r.subject.subject,
        context: context
      }))));
    }
    // List all available personas for the session. Optionally pass a persona type to filter by that persona.
    listPersonas(sessionId, personaType) {
      return this.api.listPersonas({
        session: sessionId,
        pageSize: 100,
        type: personaType
      }).pipe(map(r => {
        const personas = [];
        if (!r || !r.personas) {
          return [];
        }
        for (const p of r.personas) {
          const persona = fromPersona(p);
          if (!!persona) {
            personas.push(persona);
          }
        }
        return personas;
      }));
    }
    // Get a short lived session token
    getToken() {
      return this.api.getToken({}).pipe(map(r => r.token));
    }
    // Login into a user. Optionally specify the partner and persona type you want to log into
    login(email, password, personaType, partnerId) {
      return this.httpApi.login({
        email: email,
        password: password,
        namespace: partnerId,
        type: personaType
      }).pipe(map(r => r.sessionId || ''));
    }
    // Logout of the current session, returns true if successful
    logout() {
      return this.httpApi.logout().pipe(map(r => r.success));
    }
    // This will redirect the browser to IAM's sso login handler.
    ssoLogin(nextUrl, personaType, partnerId) {
      this.httpApi.ssoLogin({
        nextUrl: nextUrl,
        namespace: partnerId,
        type: personaType
      });
    }
    // getMultiUsers takes an array of user identifiers and calls IAM to convert them into Users
    getMultiUsers(userIdentifiers) {
      return this.iamApi.getMultiUsers({
        userIdentifiers
      }).pipe(map(resp => {
        if (!!resp.users) {
          return resp.users;
        }
        return [];
      }), map(userContainers => userContainers.map(u => u.user)));
    }
    // listSecurityLogs returns security logs for a userId passed in. This is a paged function, but the
    // handling of paged information is left to the implementor (for now).
    listSecurityLogs(userId, cursor, pageSize, actionId = '') {
      const optionalArgs = {};
      if (actionId !== '') {
        optionalArgs.filters = new ListSecurityLogsRequestFilters({
          actionId
        });
      }
      return this.iamApi.listSecurityLogs({
        userId,
        cursor,
        pageSize,
        ...optionalArgs
      });
    }
    // listUsers returns users for a namespace passed in. This is a paged function, but the
    // handling of paged information is left to the implementor (for now).
    // An empty namespace will return users that exist outside of a namespace.
    listUsers(namespace, email, cursor, pageSize, subjectTypes, searchTerms, sortOptions) {
      const userFilter = {};
      if (!!subjectTypes && subjectTypes.length > 0) {
        userFilter.subjectTypes = subjectTypes;
      }
      if (!!searchTerms && searchTerms.length > 0) {
        userFilter.searchTerms = searchTerms;
      }
      return this.iamApi.listUsers({
        namespace: namespace,
        email: email,
        cursor: cursor,
        pageSize: pageSize,
        userFilter: userFilter,
        sortOptions: sortOptions || []
      });
    }
  }
  IAMService.ɵfac = function IAMService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || IAMService)(i0.ɵɵinject(UserIAMApiService), i0.ɵɵinject(IamHttpApiService), i0.ɵɵinject(IAMApiService));
  };
  IAMService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: IAMService,
    factory: IAMService.ɵfac,
    providedIn: 'root'
  });
  return IAMService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************

/**
 * Generated bundle index. Do not edit.
 */

export { Access, AccessCheckFailures, AccessResourceRequest, AccessResourceRequestResourceEntityIdentifierEntry, AccessScope, AddKeyRequest, AddKeyResponse, AddMultiUserRestrictionRequest, AlgorithmType, Attribute, AuthenticateSubjectRequest, BasePersona, BooleanOperator, CRMRolePersona, ChangeSubjectEmailRequest, Context, CreateExternalIDRequest, CreateSessionRequest, CreateSessionResponse, CreateTemporarySubjectRequest, CreateTemporarySubjectResponse, DeleteSubjectRequest, DeleteUserRequest, DeveloperPersona, DigitalAgentPersona, FieldMask, ForOperator, GeoPointAttribute, GetImpersonationTokenRequest, GetImpersonationTokenResponse, GetMultiExternalIDRequest, GetMultiExternalIDResponse, GetMultiUsersRequest, GetMultiUsersResponse, GetMultiUsersResponseUserContainer, GetResetPasswordTokenRequest, GetSessionTokenRequest, GetShortLivedTokenRequest, GetSubjectBySessionRequest, GetSubjectContextRequest, GetSubjectContextResponse, GetSubjectResponse, GetSubjectsByEmailRequest, GetSubjectsRequest, GetSubjectsResponse, GetTokenRequest, GetTokenResponse, HostService, IAMApiService, IAMListPersonasRequest, IAMService, Identifier, IfClause, ListAttribute, ListPersonasByEmailRequest, ListPersonasRequest, ListPersonasResponse, ListSecurityLogsRequest, ListSecurityLogsRequestFilters, ListSecurityLogsResponse, ListUsersRequest, ListUsersResponse, MultiValueAttribute, MutateAttributesRequest, Mutation, NamespacedContext, NamespacedEmail, NamespacedPersona, NamespacedSession, OAuthCredentials, Operator, OrderByDirection, PartnerAppPersona, PartnerPersona, Persona, PersonaType, Policy, PolicyNode, PublicKey, Query, RegisterPolicyRequest, RegisterResourceOwnerRequest, RegisterResourceRequest, RegisterSubjectRequest, RegisterSubjectResponse, RemoveKeyRequest, RemoveMultiUserRestrictionRequest, ResetPasswordTokenResponse, ResetPasswordWithTokenRequest, ResetSubjectPasswordRequest, ResourceIdentifier, ResourceIdentifierIdentifiersEntry, ResourceOwner, RestrictionType, SMBPersona, SalespersonPersona, SearchSubjectRequest, SearchSubjectResponse, SecurityLog, SendEmailVerificationRequest, SingleValueAttribute, SortDirection, StructAttribute, StructAttributeAttributesEntry, Subject, SubjectCredentials, SubjectMissingValueClause, SubjectResourceForClause, SubjectResourceIntersectionClause, SubjectResourceSubsetClause, SubjectResult, SubjectValueIntersectionClause, TypedContext, TypedExternalIdentifier, TypedPersona, UpdateUserRequest, UpdateUserRequestOperation, User, UserFilter, UserIAMApiService, UserIdentifier, UserSortField, UserSortOptions, ValueList, VendorPersona, VerifyEmailRequest, fromPersona };
